// ABOUTME: Calculates whether applicant verification can render after CV parsing.
// ABOUTME: Separates recoverable parser item errors from items with no parsed CV data.
type VerificationReadinessParams = {
    hasRouteOperation: boolean;
    requestFinished: boolean;
    readyCV: boolean;
    readyTranslation: boolean;
    hasLocalUploadCv: boolean;
    hasLocalParsedCV: boolean;
    hasParserResponse: boolean;
    hasParserCv: boolean;
};

type VerificationExitParams = {
    hasRouteOperation: boolean;
    requestFinished: boolean;
    requestFailed: boolean;
    hasParserResponse: boolean;
    hasParserCv: boolean;
};

type CvValueParams = {
    currentCv?: Compleo.IObject | null;
    parserCv?: Compleo.IObject | null;
};

export const canRenderApplicantVerificationData = (
    params: VerificationReadinessParams
) => {
    const {
        hasRouteOperation,
        requestFinished,
        readyCV,
        readyTranslation,
        hasLocalUploadCv,
        hasLocalParsedCV,
        hasParserResponse,
        hasParserCv
    } = params;
    const hasRequiredParsedCV = !hasLocalUploadCv || hasLocalParsedCV;
    const hasRequiredCV = readyCV || (hasRouteOperation && hasParserCv);

    return (
        readyTranslation &&
        (!hasRouteOperation || requestFinished) &&
        hasRequiredCV &&
        hasRequiredParsedCV &&
        hasParserResponse
    );
};

export const shouldLeaveApplicantVerificationData = (
    params: VerificationExitParams
) =>
    params.hasRouteOperation &&
    (params.requestFailed ||
        (params.requestFinished &&
            (!params.hasParserResponse || !params.hasParserCv)));

export const hasPersistedCv = (cv: Compleo.IObject | undefined | null) =>
    Boolean(cv?.key && cv?.originalFileName);

export const getCvValueForParserSubmission = ({
    currentCv,
    parserCv
}: CvValueParams) => {
    if (currentCv?.FileInfo || hasPersistedCv(currentCv)) {
        return currentCv;
    }

    if (hasPersistedCv(parserCv)) {
        return parserCv;
    }

    return currentCv;
};
